import fr from '@/translations/fr.json';
import en from '@/translations/en.json';
import { createI18n } from 'vue-i18n';

const i18n = createI18n({
    locale: 'fr_FR',
    fallbackLocale: 'fr_FR',
    allowComposition: true,
    messages: {
        fr_FR: fr,
        en_EN: en,
    },
});

const { t } = i18n.global;

export { t };

export default i18n;
